var exports = {
  "uW": "section__DGu7ty",
};

module.exports = exports;
